import { defineComponent as _defineComponent } from 'vue'
import { ref } from "vue";
import CouponsRepository from "@/utils/API/CouponsRepository";
import {useNotify} from "@/hooks/useNotify";


export default /*#__PURE__*/_defineComponent({
  __name: 'CouponRedemptionForm',
  emits: ["couponRedeemed"],
  setup(__props, { emit }) {




const couponCode = ref("");
const loading = ref(false);

const notify = useNotify();

async function redeemCoupon() {
  loading.value = true;

  try {
    const response = await CouponsRepository.checkCoupon(couponCode.value);
    notify.success("Successfully loaded coupon.");
    emit("couponRedeemed", response.data.result);
  }

  catch {
    notify.error("Invalid coupon.");
  }

  finally {
    loading.value = false;
  }
}

return { __sfc: true,emit, couponCode, loading, notify, redeemCoupon }
}

})